import { useMatrixNavigation } from '@app/utils/hooks/matrix/useMatrixNavigation';
import { Id, Position } from '@typings';

import { PrepackSwitch } from '../MatrixContents/PrepackSwitch';

interface Props {
  variantId: Id;
  isDisabled: boolean;
  position: Position;
}

export const PrepackSwitchCell = ({ variantId, isDisabled, position }: Props) => {
  const { setFocusableElement, isFocusTarget, isFocused, isSelected } = useMatrixNavigation(position);

  return (
    <td className="border-2 border-transparent p-0">
      <PrepackSwitch
        ref={setFocusableElement}
        isDisabled={isDisabled}
        isFocusTarget={isFocusTarget}
        variantId={variantId}
        isSelected={isSelected || isFocused}
      />
    </td>
  );
};
